import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'firebase';
import { ToastrService } from 'ngx-toastr';
import { Quiniela } from 'src/app/models/quiniela';
import { Jugador } from 'src/app/models/jugador';
import { Partido } from 'src/app/models/partido';
import { QuinielaJugada } from 'src/app/models/quiniela-jugada';
import { AuthService } from 'src/app/services/auth.service';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { JugadorService } from 'src/app/services/jugadores.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { QuinielaJugadaService } from 'src/app/services/quiniela-jugada.service';
import { SmsService } from 'src/app/services/sms.service';
import Swal from 'sweetalert2'


@Component({
  selector: 'app-eliminar-quiniela-page',
  templateUrl: './eliminar-quiniela-page.component.html',
  styleUrls: ['./eliminar-quiniela-page.component.css']
})
export class EliminarQuinielaPageComponent implements OnInit {
  quinielas: Array<Quiniela> = [];
  user: User = null;
  isAuthenticated = false;
  isLoading = true;

  constructor(
    private authService: AuthService,
    private QuinielasService: QuinielasService,
    private JugadoresService: JugadorService,
    private PartidosService: PartidosService,
    private QuinielaJugadaService: QuinielaJugadaService,
    private router: Router,
    private toastr: ToastrService,
    private SmsService: SmsService,
  ) { }

  ngOnInit(): void {
    this.getCurrentUser();
  }

  getCurrentUser(): void {
    this.authService.getCurrentUser().subscribe((response) => {
      if (response) {
        this.user = response;
        this.isAuthenticated = true;
        this.getAllQuinielasDeUnUsuario();
        return;
      }
      this.isAuthenticated = false;
    });
  }

  // Obtener las Quinielas
  getAllQuinielasDeUnUsuario(): void {
    this.isLoading = true;
    this.QuinielasService.getAllQuinielasDeUnUsuario(this.user.email).subscribe((items) => {
      // Setting up quinielas
      this.quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );

      // Terminar cargando
      this.isLoading = false;
    });

  }

  eliminar(quiniela: Quiniela): void {

    Swal.fire({
      title: 'Atención',
      text: "¿Estas seguro que deseas eliminar esta quiniela?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        let timerInterval
        Swal.fire({
          title: 'Eliminando',
          html: 'Se esta eliminando la quiniela.Por favor espere <b></b> millisegundos.',
          timer: 10000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
              b.textContent = `${Swal.getTimerLeft()}`
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            console.log('I was closed by the timer');
            this.toastr.success('La quiniela fue eliminada con éxito!');
          }
        })

        // Una especie de borrado logico que lo que hace es borrar el user de la quiniela
        quiniela.user = "";

        // Enviar a Firebase mediante el Servicio
        this.QuinielasService.updateQuiniela(quiniela, quiniela.$key).then((res) => {
          console.log("Se ha borrado logicamente con exito la Quiniela");
        });

        // Enviar SMS avisando que se registro con exito
        var numero = "+584122924248";
        var texto = "*TuQuinielaYa:* La quiniela " + quiniela.titulo + " ha sido eliminada.";
        this.SmsService.enviar(numero, texto);

      }
    });

  }

}
